export default {
  routeDetails: {
    routeDetails: 'Routendetails',
    warnings: 'Warnungen',
    routes: 'Routen',
    route: 'Route',
    segments: 'Abschnitte',
    segment: 'Abschnitt',
    instructions: 'Wegbeschreibungen',
    instruction: 'Wegbeschreibung',
    name: 'Name',
    selectRoute: 'Diese Route farbig darstellen',
    selectedRoute: 'Farbig dargestellte Route',
    gotoSegment: 'Gehe zu Abschnitt',
    warningCodes: {
      1: 'Auf einigen Straßen können Zufahrts- oder Zugangsbeschränkungen gelten',
      2: 'Diese Route nutzt Mautstraßen',
      3: 'Auf der Route gibt es übersprungene Abschnitte. Dauer und Zugangsbeschränkungen sind möglicherweise nicht korrekt.',
      4: 'Mindestens eine angefragte Zusatzinformation ist nicht verfügbar.'
    },
    routeOpacity: 'Routendeckkraft',
    heatRoute: 'Niedrige Sonneneinstrahlung',
    fastestRoute: 'Schnellste Route',
    legendHigh: 'Hohe Solarexposition - wenig Schatten',
    legendMid: 'Mittlere Solarexposition - teilweise Schatten',
    legendLow: 'Niedrige Solarexposition - größtenteils Beschattet',
    legend: 'Legende'
  }
}
